import aa from 'search-insights'
import { global } from './constants'
import { routeForRole, openProfilePage } from './utils'
import lockImage from './lock-icon.svg'
import React, { useEffect, useRef } from 'react'
import { Tooltip } from 'bootstrap'
import { find, intersection, values } from 'underscore'

export const SuggestionItem = ({
  person,
  personalInfo,
  position,
  adminSiteIds,
  usesAdvancedSiteManagement,
  onClick
}) => {
  aa('init', { appId: global.applicationId, apiKey: global.searchKey }) // initializing search insights library for click tracking

  const handleOnClick = onClick ? onClick : openProfilePage

  const tooltipRef = useRef()

  const tooltipText = 'You only have limited access to this client, because they are not assigned to any of your Sites'
  useEffect(() => {
    if (tooltipRef.current) {
      new Tooltip(tooltipRef.current, {
        html: true,
        title: tooltipText
      })
    }
  }, [tooltipRef])


  const handleRowClick = event => handleOnClick(event, person.role, position, person)

  const client = person.client || person.caller
  const adminAdministeredClientSites = intersection(adminSiteIds, person.display_site_ids)
  const limitedAccess = client && usesAdvancedSiteManagement && adminAdministeredClientSites.length === 0
  let icon = person.icon || 'fa-regular fa-address-book fa-lg'

  return (
    <div role='row' className='row search-result-row'>
      <div
        role='rowheader'
        className='col-4 my-1 my-xl-0 d-flex flex-row align-items-center'
        id={`person_${person.id}`}
        onClick={handleRowClick}
      >
        <span className='pe-3'>
          <i className={icon}></i>
        </span>
        {person.name || person.full_name}
      </div>
      <div role='cell' className='col-7 my-1 my-xl-0 d-flex flex-row align-items-center' onClick={handleRowClick}>
        <span>
          {person.details?.map((detail, index) => {
            return (
              <React.Fragment key={index}>
                {!!index && <span className='ms-2 me-2'>•</span>}
                {detail}
              </React.Fragment>
            )
          })}
        </span>
      </div>
      <div role='cell' className='col-1 my-1 my-xl-0 d-flex flex-row' onClick={handleRowClick}>
        {/* set proper href for a11y purposes even though default will be prevented */}
        <a
          href={routeForRole(null, person)}
          target='_blank'
          className={'new-window-icon'}
          onClick={event => openProfilePage(event, null, position, person, true)}
        >
          <i className='fa-solid fa-arrow-up-long fa-rotate-by fa-lg' style={{ '--fa-rotate-angle': '45deg' }}></i>
          <span className='visually-hidden'>Open profile in new window</span>
        </a>
        {usesAdvancedSiteManagement && limitedAccess && (
          <span className={'ps-4'} style={{ paddingTop: '0.125rem' }} ref={tooltipRef}>
            <img src={lockImage} className='lock-icon' alt={tooltipText} />
          </span>
        )}
        <button type='button' className='visually-hidden' onClick={handleRowClick}>
          Select this person
        </button>
      </div>
    </div>
  )
}
